export default __webpack_public_path__ + "static/media/trash-icon.d358de75.svg";